__turbopack_context__.v({
  "isExpired": "statusIndicator-module-scss-module__BiwfyG__isExpired",
  "isLive": "statusIndicator-module-scss-module__BiwfyG__isLive",
  "isPending": "statusIndicator-module-scss-module__BiwfyG__isPending",
  "isPublished": "statusIndicator-module-scss-module__BiwfyG__isPublished",
  "isScheduled": "statusIndicator-module-scss-module__BiwfyG__isScheduled",
  "isUnpublished": "statusIndicator-module-scss-module__BiwfyG__isUnpublished",
  "statusIndicator": "statusIndicator-module-scss-module__BiwfyG__statusIndicator",
  "statusIndicatorLabel": "statusIndicator-module-scss-module__BiwfyG__statusIndicatorLabel",
  "statusIndicatorLegend": "statusIndicator-module-scss-module__BiwfyG__statusIndicatorLegend",
  "statusIndicatorLegendItem": "statusIndicator-module-scss-module__BiwfyG__statusIndicatorLegendItem",
});
